import { Client } from "./_clientService";

async function getObjectiveTypeTitles() {
  try {
    const resp = await new Client({
      path: "/objective-type-titles/list",
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function getObjectiveTypeTitleInfo(objectiveTypeTitleId: any) {
  try {
    const resp = await new Client({
      path: "/objective-type-titles/info",
      payload: { objectiveTypeTitleId },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function createObjectiveTypeTitle(details: any) {
  try {
    const resp = await new Client({
      path: "/objective-type-titles/create",
      payload: details,
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function updateObjectiveTypeTitle(details: any, id: any) {
  try {
    const resp = await new Client({
      path: "/objective-type-titles/update",
      payload: { ...details, _id: id },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function deleteObjectiveTypeTitle(objectiveTypeTitleId: any) {
  try {
    const resp = await new Client({
      path: "/objective-type-titles/delete",
      payload: { objectiveTypeTitleId },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

export {
  getObjectiveTypeTitles,
  getObjectiveTypeTitleInfo,
  createObjectiveTypeTitle,
  updateObjectiveTypeTitle,
  deleteObjectiveTypeTitle,
};
